import Icon from '../components/Icon.vue'

Icon.register({
  'pen-nib': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M136.6 138.8A64-64 0 0 1 93.3 180.1L0 460 14.7 474.7 164.8 324.6C161.8 318.3 160 311.4 160 304 160 277.5 181.5 256 208 256S256 277.5 256 304 234.5 352 208 352C200.6 352 193.7 350.2 187.4 347.2L37.3 497.3 52 512 331.9 418.7A64-64 0 0 1 373.2 375.4L416 224 288 96 136.6 138.8zM497.9 74.2L437.8 14.1C419.1-4.7 388.7-4.7 369.9 14.1L313.4 70.6 441.4 198.6 497.9 142.1C516.7 123.3 516.7 92.9 497.9 74.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pen-nib.js
// module id = eW6M
// module chunks = 144